import { notificationsSignal } from "../signals/notificationSignals"

export const addNotification = (message, type, surviveRedirect = false, headerMessage, textColor) => {
    // add the new notification to our toasts signal. Set redirectCount to 2 if the it is intended to persist after redirect to another page
    let _type = type ? type : 'danger'
    let _headerMessage = headerMessage ? headerMessage : (_type == NotificationTypes.SUCCESS ? 'Success' : 'Error'); // use headerMessage if passed. Otherwise use either Success or Error
    notificationsSignal.value = [
        ...notificationsSignal.value, {
        type: _type,
        headerMessage: _headerMessage, 
        message: message ? message: '', 
        redirectCount: surviveRedirect ? 2 : 1, 
        textColor: textColor ? textColor : 'text-white'}]
}

export const notifyException = (exception, headerMessage = 'Error') => {
    addNotification(exception.message, NotificationTypes.ERROR, true, headerMessage)
}

// This function is called by our route handling code to clear out old notifications. 
export const clearNotifications = () => {
    // decrement the redirectCount of all messages
    const decrementedNotifications = notificationsSignal.value.map(t => {
        t.redirectCount = t.redirectCount - 1
        return t
    })

    // filter to just toasts that should still exist
    const filtered = decrementedNotifications.filter(t => t.redirectCount > 0)

    // update signal with remaining items
    notificationsSignal.value = filtered
}

export const NotificationTypes = Object.freeze({
    ERROR: 'danger',
    INFO: 'info',
    SUCCESS: 'success'
})
